import classnames from 'classnames';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function getClassName(...args) {
  return classnames(args);
}

export function cn(...inputs) {
  return twMerge(classnames(inputs));
}
